import { FlexCenterWrapper } from "../../../../components/DefaultNoDataWrapper";
import Flex from "../../../../components/Flex";
import { ScrollArea } from "../../../../components/ScrollBar";
import Text from "../../../../components/Text";
import useCurrentUser from "../../../../hooks/local-storage/use-current-user";
import useDisclosure from "../../../../hooks/use-disclosure";
import { useGetInsuranceByPatientId } from "../../../../queries/insurance/use-get-patient-insurance-patient-uuid";
import InsuranceCard from "../../../../pages/app/provider/patient/patient-list/patient-chart-new/demographics/insurance/InsuranceCard";
import UpsertInsuranceFormModal from "../../../../pages/app/provider/patient/patient-list/patient-chart-new/demographics/insurance/UpsertInsuranceFormDrawer";
import noDataImg from "/default-images/no Data Found.svg";

const PatientPortalInsurance = () => {
  const [me] = useCurrentUser();
  const editPatientInsuranceDisclosure = useDisclosure();
  const { data: insuranceData }: any = useGetInsuranceByPatientId(me?.uuid);

  const handleEditInsurance = (item: any) => {
    editPatientInsuranceDisclosure.open({
      patientInsurances: [
        {
          ...item,
          insurancePayer: {
            payerId: {
              value: item?.insurancePayer?.payerId,
              label: item?.insurancePayer?.payerName ?? "",
            },
          },
          planId: item?.planId
            ? {
                value: item?.planId,
                label: item?.planName,
              }
            : undefined,
          provider: Object.keys(item?.provider ?? {})?.length
            ? {
                value: Object.keys(item?.provider)[0],
                label: Object.values(item?.provider)[0],
              }
            : undefined,
        },
      ],
    });
  };

  return !!insuranceData?.content?.length ? (
    <ScrollArea height={"calc(100vh - 300px)"} width={"100%"}>
      <UpsertInsuranceFormModal
        disClosureHost={editPatientInsuranceDisclosure}
        title="Edit Insurance"
      />
      <Flex gap={1.5} flexDirection={"column"} height={"100%"}>
        {insuranceData.content.map((item: any) => (
          <Flex
            key={item?.uuid}
            flexDirection={"row"}
            gap={0.5}
            width={"100%"}
            sx={{ "& > div": { width: "100%" } }}
          >
            <InsuranceCard item={item} onEditInsurance={handleEditInsurance} />
          </Flex>
        ))}
      </Flex>
    </ScrollArea>
  ) : (
    <NoDataAvailable />
  );
};

export default PatientPortalInsurance;

const NoDataAvailable = () => (
  <Flex height={"calc(100vh - 300px)"} width={"100%"}>
    <FlexCenterWrapper>
      <img src={noDataImg} alt={"No Data Available"} />
      <Text fontSize={"16px"}>No Insurances Found</Text>
    </FlexCenterWrapper>
  </Flex>
);
